import React, { memo } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { Badge, Icon, Tooltip } from 'antd';

import EditableItem from '../../EditableItem/EditableItem';

import editDocumentActions from '../../store/actions/edit-document.actions';
import documentEditMode from '../../constants/documentEditMode';
import { declOfNum, dspxDiffDays } from '../../../../helpers/dspx-utils';
import { docTypes } from '../../constants/documents.constants';

const DoneDateCell = memo(
  ({ record, getPopupContainer = () => document.body }) => {
    const dispatch = useDispatch();

    // если будет необходим подсчет на фронтенде
    // const drCalculated = (record.doneDate ? dspxDiffDays(0, record.doneDate) : null);
    const dr = record.expiredDays;

    const bgr = '#d8f2ff';
    const fgr = '#0d6aa2';
    const tlr =
      'Просрочено на ' +
      (dr > 0
        ? dr +
          declOfNum(dr, [' день', ' дня', ' дней']) +
          (record.doneDate ? '' : ' / Нет даты назначения')
        : '?');

    const expiredBadge =
      !isNaN(dr) && dr > 0 ? (
        <Tooltip
          title={tlr}
          mouseLeaveDelay={0}
        >
          <Badge
            count={
              <Icon
                type="fire"
                theme="twoTone"
                style={{ fontSize: 20 }}
                twoToneColor={dr > 14 ? '#ff0003' : '#f44336'}
              />
            }
          >
            <div
              style={{
                top: '4px',
                right: '4px',
                backgroundColor: bgr,
                color: fgr,
                borderRadius: '12px',
                padding: '4px 8px',
                fontSize: '12px',
                textAlign: 'center',
                cursor: 'default',
                minWidth: '20px',
                display: 'inline-block',
                cursor: 'pointer',
              }}
            >
              {dr > 0 ? dr : '?'}
            </div>
          </Badge>
        </Tooltip>
      ) : null;

    return (
      <div
        style={{
          whiteSpace: 'nowrap',
          marginTop: '-4px',
        }}
      >
        <EditableItem
          allowedForAppointedWorker
          record={record}
          editText={
            record.doneDate
              ? `Изменить дату ${
                  record?.type?.id === docTypes.outgoing ? 'отправки' : 'ответа'
                }`
              : `Добавить дату ${
                  record?.type?.id === docTypes.outgoing ? 'отправки' : 'ответа'
                }`
          }
          onClick={(e) => {
            e.stopPropagation();
            dispatch(
              editDocumentActions.openModal({
                ...record,
                editMode: documentEditMode.DONE_DATE,
              })
            );
          }}
          itemText={
            record.doneDate
              ? `${moment(record.doneDate).format('DD.MM.YYYY')}`
              : 'Не указана'
          }
          getPopupContainer={getPopupContainer}
        />
        {expiredBadge}
      </div>
    );
  }
);

export default DoneDateCell;
